import Vue from "vue";
import Vuex from "vuex";
import { uptDataModule } from "./modules/uptData/index.js";
import { tableViewModule } from "./modules/tableView/index.js";
import { settingsModule } from "./modules/settings/index.js";
import { showComponentsModule } from "./modules/showComponents/index.js";
import { notificationsModule } from "./modules/notifications/index.js";
import { okCancelDialogModule } from "./modules/okCancelDialog/index.js";
import { progressComponentModule } from "./modules/progressComponent/index.js";
import { buttonSelectionDialogModule } from "./modules/buttonSelectionDialog/index.js";
import { selectionModule } from "./modules/selection/index.js";
import { clipboardModule } from "./modules/clipboard/index.js";
import { genericInputDialogModule } from "./modules/genericInputDialog/index.js";

Vue.use(Vuex);
Vue.config.devtools = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    uptData: uptDataModule,
    selection: selectionModule,
    clipboard: clipboardModule,
    tableView: tableViewModule,
    settings: settingsModule,
    showComponents: showComponentsModule,
    notifications: notificationsModule,
    okCancelDialog: okCancelDialogModule,
    buttonSelectionDialog: buttonSelectionDialogModule,
    progressComponent: progressComponentModule,
    genericInputDialog: genericInputDialogModule
  },
  strict: process.env.NODE_ENV !== "production"
});
